import EnumDataSource from "utils/enum-data-source.util";

export const QUICK_FILTER_ALL_LEADS_TYPE: string = "1";
export const QUICK_FILTER_NEED_FOLLOW_UP_TYPE: string = "2";
export const QUICK_FILTER_NEW_LEAD_TODAY_TYPE: string = "3";
export const QUICK_FILTER_WAITING_FOR_RESPONSE_TYPE: string = "4";

const billingQuickFiltersType = {
  [QUICK_FILTER_ALL_LEADS_TYPE]: "All Leads",
  [QUICK_FILTER_NEED_FOLLOW_UP_TYPE]: "Need Follow Up",
  [QUICK_FILTER_NEW_LEAD_TODAY_TYPE]: "New Lead Today",
  [QUICK_FILTER_WAITING_FOR_RESPONSE_TYPE]: "Waiting For Response"
};

export const QUICK_FILTER_TYPES = new EnumDataSource(billingQuickFiltersType);
